<template>
  <div class="mock-interview-container">
    <EditorTabs
      class="mock-interview-tabs"
      :tabs="tabs"
      :activeIndex="activeIndex"
      @changeTab="changeTab"
    />
    <div v-show="activeIndex === 0" class="question-answer-container">
      <template
        v-if="
          questionState === 'answer' ||
          (questionState === 'answerLoading' && !!answerList.length)
        "
      >
        <div class="question-answer-container-scroll">
          <MessageItem
            v-for="(item, index) in answerList"
            :key="index"
            :message="item"
          />
        </div>
        <div class="flex justify-between items-center" style="margin-top: 24px">
          <span class="powered-by-chatgpt">Powered By WonderAI</span>
          <div class="flex items-center">
            <CompleteButton
              :text="''"
              type="cancel"
              class="mock-interview-btn copy-btn"
              style="width: 104px; margin-right: 16px"
              @clickBtn="getInterviewAnswer('reply')"
            >
              <template v-slot:content>
                <div class="content flex items-center">
                  <i
                    v-if="questionState === 'answerLoading'"
                    class="iconfont iconzhengzaibaocun"
                  ></i>
                  {{
                    questionState === "answerLoading" ? "AI 思考中" : "换一批"
                  }}
                </div>
              </template>
            </CompleteButton>
            <CompleteButton
              text="复制所有内容"
              class="mock-interview-btn copy-btn"
              @clickBtn="copyAllContent"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <MockInterviewEntry
          v-if="!initQuestion"
          :questionState="questionState"
          @getInterviewQuestion="getInterviewQuestion"
        />
        <div class="question-scroll-container">
          <MessageItem
            v-if="initQuestion"
            :message="{ question: initQuestion }"
          />
          <div
            v-if="
              questionState === 'complete' || questionState === 'answerLoading'
            "
            class="flex items-center"
            style="padding-left: 44px; margin-top: 24px; margin-bottom: 50px"
          >
            <CompleteButton
              :text="''"
              class="mock-interview-btn"
              @clickBtn="getInterviewAnswer"
            >
              <template v-slot:content>
                <div class="content flex items-center">
                  <i
                    v-if="questionState === 'answerLoading'"
                    class="iconfont iconzhengzaibaocun"
                  ></i>
                  {{
                    questionState === "answerLoading" ? "AI 思考中" : "查看回答"
                  }}
                </div>
              </template>
            </CompleteButton>
            <MemberTips
              v-if="!isMembership"
              style="margin-left: 16px"
              @buyMember="buyMember"
            />
          </div>
        </div>
      </template>
    </div>
    <AnswerByMyself
      v-show="activeIndex === 1"
      @buyMember="buyMember"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import api from "@/api";
import CompleteButton from "../CompleteButton/CompleteButton.vue";
import EditorTabs from "../EditorTabs/EditorTabs.vue";
import MockInterviewEntry from "./Entry.vue";
import MessageItem from "./MessageItem.vue";
import MemberTips from "./MemberTips.vue";
import AnswerByMyself from "./AnswerByMyself.vue";
import { copyToClipboard } from "@/assets/js/util";

export default {
  name: "MockInterview",
  components: {
    CompleteButton,
    EditorTabs,
    MockInterviewEntry,
    MessageItem,
    MemberTips,
    AnswerByMyself,
  },
  data() {
    return {
      initQuestionList: [],
      initQuestion: "",
      questionState: "",
      answerList: [],
      tabs: ["AI 模拟面试", "我要自己问"],
      activeIndex: 0,
    };
  },
  computed: {
    ...mapState("me", ["isMembership"]),
  },
  methods: {
    changeTab(index) {
      this.activeIndex = index;
    },
    buyMember() {
      this.$emit("buyMember");
    },
    async copyAllContent() {
      const content = this.answerList
        .map(
          (item, index) =>
            `问题${index + 1}：${item.question}\n面试思路：${
              item.logic
            }\n面试话术：${item.answer}`
        )
        .join("\n\n");
      await copyToClipboard(content);
      this.$message.success("已复制内容");
    },
    async getInterviewQuestion() {
      try {
        if (
          this.questionState === "loading" ||
          this.questionState === "answerLoading"
        )
          return;
        this.questionState = "loading";
        this.initQuestion = "";
        this.answerList = [];
        api.cvsEditor.fetchMockInterviewResultStream({
          data: {
            cv_token: this.$store.state.editor.cvDetail.basic_info.token,
            ask_type: "question",
          },
          onMessage: (data = {}) => {
            if (data?.choices?.length) {
              data.choices.forEach((item) => {
                if (item?.delta?.content) {
                  this.initQuestion += item.delta.content;
                }
              });
            }
          },
          onComplete: () => {
            this.questionState = "complete";
          },
          onError: (error) => {
            console.log(error);
            this.questionState = "error";
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getInterviewAnswer(type) {
      try {
        if (!this.isMembership) {
          this.$emit("buyMember");
          return;
        }
        if (this.questionState === "answerLoading") return;
        this.questionState = "answerLoading";
        const res = await api.cvsEditor.getInterviewAnswer({
          ask_type: "answer",
          is_continue: false,
          change: false,
          question: type === "reply" ? undefined : this.initQuestion,
          cv_token: this.$store.state.editor.cvDetail.basic_info.token,
        });
        if (res.code === 1000) {
          this.answerList = res.data.result;
          this.questionState = "answer";
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";

.mock-interview-container {
  width: 100%;
  height: 100%;
  padding: 0 24px;
  .mock-interview-tabs {
    height: 22px;
    margin-bottom: 24px;
  }
  .mock-interview-btn {
    border-radius: 18px;
    width: 132px;
    height: 36px;
    font-size: 14px;
    white-space: nowrap;
    .content {
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .iconfont {
        font-size: 14px;
        margin-right: 6px;
        animation: spin 2s linear infinite;
      }
    }
  }
  .question-answer-container {
    height: calc(100% - 46px);
    .question-scroll-container {
      height: 100%;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .question-answer-container-scroll {
      overflow-y: scroll;
      height: calc(100% - 106px);
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .powered-by-chatgpt {
      color: $powered-by-chatgpt;
      font-size: 12px;
    }
  }
  .mock-interview-questions {
    color: $text-color;
    white-space: pre-line;
  }
}
</style>
